import React from 'react';
import './UKUniversities.css';

const universities = {
  A: [
    "University of Amsterdam (Netherlands)",
    "Aarhus University (Denmark)",
    "Alma Mater Studiorum - University of Bologna (Italy)",
  ],
  B: [
    "Bocconi University (Italy)",
    "Budapest University of Technology and Economics (Hungary)",
  ],
  C: [
    "Charles University (Czech Republic)",
    "Catholic University of Louvain (Belgium)",
  ],
  E: [
    "Eindhoven University of Technology (Netherlands)",
    "École Normale Supérieure de Lyon (France)",
    "ETH Zurich (Switzerland)",  // Technically Switzerland, but part of Europe
  ],
  F: [
    "Free University of Berlin (Germany)",
    "Freie Universität Berlin (Germany)",
  ],
  H: [
    "Heidelberg University (Germany)",
  ],
  K: [
    "KU Leuven (Belgium)",
  ],
  L: [
    "Ludwig Maximilian University of Munich (Germany)",
    "Leiden University (Netherlands)",
    "London School of Economics and Political Science (United Kingdom)",  // Optional, if you count UK in Europe
  ],
  P: [
    "Politecnico di Milano (Italy)",
    "Pierre and Marie Curie University (France)",
  ],
  S: [
    "Sorbonne University (France)",
    "Stockholm University (Sweden)",
    "Sapienza University of Rome (Italy)",
  ],
  T: [
    "Technical University of Munich (Germany)",
    "Trinity College Dublin (Ireland)",
  ]
};

const EuropeUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Europe Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EuropeUniversities;
